// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"31d6cfe0","258":"b1ddbc96","348":"7c411135"}[chunkId] + ".chunk.css";
};